<template>
     <div class="marquee animate" :class="dynamicClasses">
            <div class="container">
                <p class="text">
                    <template v-for="n in 10">
                    &nbsp;{{text}}&nbsp;
                    </template>
                    
                </p>
            </div>
        </div>
</template>

<script>
    export default {
        props: {
            text: {
                type: String,
                default: ''
            },
            isWhite: {
                type: Boolean,
                default: false
            },
            isYellow: {
                type: Boolean,
                default: false
            },
            isBlack: {
                type: Boolean,
                default: true
            }
    },
        computed: {
            dynamicClasses() {
            return {
                "-is-white": this.isWhite,
                "-is-yellow": this.isYellow,
                "-is-black": this.isBlack,
            };
        },
        },
    }
</script>